import React from 'react';
import { Pressable, ScrollView, StyleSheet, View } from 'react-native';
import { Glyph } from './Glyph';
import { theme } from '../theme';
/** Max width of the Settings dropdown; on phones it spans the window. */
export const CLIENT_MENU_MAX_WIDTH = 400;
/** Cap the dropdown; the scroll view itself carries this so iOS Safari scrolls it. */
export const CLIENT_MENU_MAX_HEIGHT = 560;
/**
 * Client web Settings button, shown in the "Abbi's Way" title bar to the left
 * of the title (admins keep the side panel). Same person icon and well as the
 * native Home header's Settings button.
 */
export const ClientSettingsButton = ({ open, onPress }) => (<Pressable style={styles.iconHit} onPress={onPress} accessibilityRole="button" accessibilityLabel="Settings" accessibilityState={{ expanded: open }} testID="client-settings-button">
    <View style={styles.settingsIconWell}>
      <Glyph name="person" size={24} color={theme.colors.accent}/>
    </View>
  </Pressable>);
/**
 * Settings dropdown. Render it at the top of the screen content so it opens
 * just below the title bar; anchored left, capped at CLIENT_MENU_MAX_WIDTH.
 * The backdrop or the close button closes it (the title-bar icon toggles).
 */
export const ClientSettingsMenu = ({ open, onClose, renderMenu }) => {
    if (!open) {
        return null;
    }
    return (<>
      <Pressable style={styles.scrim} onPress={onClose} accessibilityLabel="Close settings" testID="client-menu-scrim"/>
      <View style={styles.menu} testID="client-menu">
        <Pressable style={styles.closeHit} onPress={onClose} accessibilityRole="button" accessibilityLabel="Close settings" testID="client-menu-close">
          <Glyph name="close" size={22} color={theme.colors.textCaption}/>
        </Pressable>
        <ScrollView style={styles.menuScroll} contentContainerStyle={styles.menuContent} testID="client-menu-scroll">
          {renderMenu()}
        </ScrollView>
      </View>
    </>);
};
const styles = StyleSheet.create({
    iconHit: {
        minWidth: 44,
        minHeight: 44,
        marginLeft: 4,
        alignItems: 'center',
        justifyContent: 'center',
    },
    /** Same well as the native Home header's Settings button. */
    settingsIconWell: {
        width: 36,
        height: 36,
        borderRadius: 18,
        backgroundColor: theme.colors.surfaceIconWell,
        alignItems: 'center',
        justifyContent: 'center',
    },
    scrim: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: 10000,
        backgroundColor: 'rgba(0,0,0,0.3)',
        zIndex: 10,
    },
    menu: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        maxWidth: CLIENT_MENU_MAX_WIDTH,
        maxHeight: CLIENT_MENU_MAX_HEIGHT,
        backgroundColor: theme.colors.surfaceElevated,
        borderBottomLeftRadius: 12,
        borderBottomRightRadius: 12,
        borderRightWidth: StyleSheet.hairlineWidth,
        borderRightColor: theme.colors.hairline,
        zIndex: 11,
    },
    closeHit: {
        position: 'absolute',
        top: 4,
        right: 4,
        minWidth: 44,
        minHeight: 44,
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1,
    },
    menuScroll: {
        // On the scroller, not only the parent. iOS Safari will not scroll a
        // child when the cap is an ancestor with overflow visible.
        maxHeight: CLIENT_MENU_MAX_HEIGHT,
        minHeight: 0,
    },
    menuContent: {
        paddingBottom: 8,
    },
});
